<template>
  <div class="result-step-component">
    <h1 class="step-title font-weight-regular">
      Подтверждение заказа
    </h1>

    <div class="button-group d-flex justify-between">
      <v-row dense class="justify-space-between">
        <v-col sm="5">
          <v-btn
            @click="stepBack"
            class="button button-back"
            width="100%"
            color="#F1F3F6"
          >
            <font-awesome-icon icon="chevron-left" />
            Вернуться назад
          </v-btn>
        </v-col>
        <v-col sm="5"></v-col>
      </v-row>
    </div>

    <div class="basket-items-section">
      <v-row>
        <v-col v-for="(item, i) in basketItems" :key="i" sm="6">
          <basket-item :item="item" />
        </v-col>
      </v-row>
    </div>

    <div class="info-section">
      <span class="info-title">
        Итого к оплате:
        <span class="font-weight-regular">{{ basket.totalPrice }} ₽</span>
      </span>
    </div>

    <div class="info-section">
      <span class="info-title">
        Адрес:
        <span class="font-weight-regular">
          {{ basket.clientAddress.street }}, д.
          {{ basket.clientAddress.house }}, подъезд
          {{ basket.clientAddress.entry }}, кв
          {{ basket.clientAddress.apartmentNumber }}</span>
      </span>
    </div>

    <div class="info-section">
      <span class="info-title">
        Доставка:
        <span class="font-weight-regular">{{ basket.deliveryPrice }} ₽</span>
      </span>
    </div>

    <div class="info-section">
      <span class="info-title">
        Количество персон:
        <span class="font-weight-regular">{{ basket.persons }}</span>
      </span>
    </div>

    <div class="info-section">
      <span class="info-title">
        Тип оплаты:
        <span class="font-weight-regular">{{ getPaymentType }}</span>
      </span>
    </div>

    <div v-if="basket.commentForCourier" class="info-section">
      <span class="info-title">
        Комментарий курьеру:
        <span class="font-weight-regular">{{ getCourierComment }}</span>
      </span>
    </div>

    <div v-if="basket.commentForCourier" class="info-section">
      <span class="info-title">
        Комментарий к заказу:
        <span class="font-weight-regular">{{ basket.comment }}</span>
      </span>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import BasketItem from './BasketItem'
  import PaymentType from '@/models/enums/PaymentType'
  import PaymentMode from '@/models/enums/PaymentMode'

  export default {
    name: 'ResultStep',
    components: {
      BasketItem,
    },
    computed: {
      ...mapState({
        basket: (state) => state.baskets.basket,
        currentEditOrder: (state) => state.orders.currentEditOrder,
      }),
      ...mapGetters({
        basketItems: 'baskets/getItems',
      }),
      getCourierComment () {
        return this.basket.commentForCourier
      },
      getPaymentType () {
        if (!this.basket.paymentType) {
          return '–'
        }

        const name = PaymentType.getName(this.basket.paymentType, this.basket.deliveryType, PaymentMode.ofOrder(this.currentEditOrder))

        return this.basket.paymentType === PaymentType.Cash
          ? `${name}, сдача с ${this.basket.clientMoney} ₽`
          : name
      },
    },
    methods: {
      stepBack () {
        this.$store.commit('newOrder/setStep', 2)
      },
    },
  }
</script>

<style lang="less" scoped>
.result-step-component {
  .step-title {
    font-size: 34px;
    line-height: 21px;
    margin-bottom: 33px;
  }

  .button-group {
    margin-bottom: 21px;

    .button {
      height: 80px;
      font-size: 15px;
      box-shadow: 0 3px 6px #00000029 !important;

      svg {
        margin-right: 8px;
      }
    }

    .button-back {
      svg {
        .fill-svg(#0033ff);
      }
    }
  }

  .basket-items-section {
    margin-bottom: 32px;
  }

  .info-section {
    .info-title {
      font-size: 32px;
      line-height: 21px;
      font-weight: 500;
      span {
        font-size: 30px;
      }
    }
    margin-bottom: 24px;
  }
}
</style>
